/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statistics_Day_Short_0Inputs */

const he_statistics_day_short_0 = /** @type {(inputs: Statistics_Day_Short_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`א`)
};

const en_statistics_day_short_0 = /** @type {(inputs: Statistics_Day_Short_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`S`)
};

/**
* | output |
* | --- |
* | "S" |
*
* @param {Statistics_Day_Short_0Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const statistics_day_short_0 = /** @type {((inputs?: Statistics_Day_Short_0Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statistics_Day_Short_0Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_statistics_day_short_0(inputs)
	return en_statistics_day_short_0(inputs)
});